var Component = require("../../model/Component");

Component.registerSubTypeDefaulter('timeline', function () {
  // Only slider now.
  return 'slider';
});


//////////////////
// WEBPACK FOOTER
// ./~/_echarts@3.8.5@echarts/lib/component/timeline/typeDefaulter.js
// module id = 704
// module chunks = 115